/**
 * Como uma sugestão do Consolidador se APRESENTA no card da fila.
 *
 * ★ O título nomeia a ENTIDADE, não a mudança. O card compartilhado titula por `CAMPOS_TITULO`
 * (`dados.nome`, `dados.titulo`, ...) justamente porque no CRM a sugestão carrega o nome da
 * entidade; as do Consolidador não carregam, e caíam no resumo do patch — o card abria com
 * "Valor unitario: 1473.080768" e o ativo ficava embaixo, menor. Quem lê a fila procura primeiro
 * QUAL ativo, e só depois O QUE muda. Aqui o de-para é montado no domínio e entregue pronto.
 *
 * ★ O rótulo do tipo vem do REGISTRY do consolidador (`Movimentação` / `Ajuste no ativo`), não do
 * `tipo` cru do backend. Todas as sugestões daqui nascem com `tipo='correcao_cadastro'`, então o
 * card dizia "Correção de cadastro" até numa correção de PU de movimentação — que não é cadastro.
 */
import { CAMPOS_DA_MOVIMENTACAO, CAMPOS_DO_ATIVO } from '@modules/consolidator/constants/Text'
import { derivarCategoria, metaDaCategoria } from '@modules/consolidator/utils/suggestions-categoria/suggestions-categoria'
import { formatNumber } from '@utils/Format'

/**
 * ★ Sem o ativo resolvido, a apresentação inteira volta `null` e o card cai no título dele —
 * NUNCA um "Ativo sem nome" chapado. O de-para chega DEPOIS da fila (é outra requisição), então
 * esse texto aparecia por 1-2s em toda carga e lia-se como cadastro sem nome ou erro no dado.
 * O mesmo vale quando a busca FALHA: título antigo é degradação; nome inventado é informação
 * errada na tela.
 */

export const nomeDoAtivo = (ativo) => {
  const a = ativo || {}
  return a.nome_ativo || a.nome || ''
}

const valorLegivel = (campo, valor) => {
  if (valor === null || valor === undefined || valor === '') return '-'
  if (CAMPOS_DA_MOVIMENTACAO[campo] && typeof valor === 'number') return formatNumber(valor)
  return String(valor)
}

export const detalheDaMudanca = (suggestion) => {
  const dados = (suggestion && suggestion.dados) || {}
  const rotulos = { ...CAMPOS_DO_ATIVO, ...CAMPOS_DA_MOVIMENTACAO }
  return Object.keys(dados)
    .filter((campo) => rotulos[campo])
    .map((campo) => `${rotulos[campo]}: ${valorLegivel(campo, dados[campo])}`)
    .join(' · ')
}

/**
 * O texto que a IA escreveu, para o modal de edicao mostrar a MESMA nota do formulario de ativo:
 * quem vai alterar um lancamento precisa ler o porquê antes, e nao so ver o campo pre-preenchido.
 */
export const textoDaSugestao = (suggestion) => {
  const s = suggestion || {}
  return s.racional || s.trecho_origem || ''
}

export const apresentacaoDaSugestao = ({ suggestion, ativo, contexto = '' } = {}) => {
  const nome = nomeDoAtivo(ativo)
  const meta = metaDaCategoria(derivarCategoria(suggestion))
  if (!nome) return { rotulo: meta.label, icone: meta.icon }
  const detalhe = detalheDaMudanca(suggestion)
  return {
    titulo: nome,
    subtitulo: [contexto, detalhe].filter(Boolean).join(' · '),
    rotulo: meta.label,
    icone: meta.icon,
  }
}
